import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brandList: [],
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    addBrandtList: (state, action) => {
      state.brandList = action.payload;
    },
    removeBrandList: (state) => {
      state.brandList = []
    }
  },
});
export const {
  addBrandtList,
  removeBrandList
} = brandSlice.actions;
export default brandSlice.reducer;
